<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (risk) {
    <div class="detail-page-action-bar">
        @if (!permissions.readonly) {
            <button class="btn btn-cerrix" (click)="save()" data-uiid="button-save-risk">
                <i class="fas fa-save"></i>
                <span class="d-none d-lg-inline">{{ 'risk.detail.saveRisk' | transloco }}</span>
            </button>
        }

        @if (risk.id > 0) {
            <span class="date-edited"> Last save: {{ risk.lastSaveDate | dateTimeFormat }} </span>
        }
    </div>
}

@if (riskLoaded) {
    <div
        class="datamanagement-screen-system"
        menuSystem
        [cerrixTab]="tab"
        (changeEvent)="handleMenuItemClick($event)"
        data-uiid="risk-detail-page"
    >
        <div
            class="risk-screens"
            [attr.name]="'Risk'"
            menuicon="fas fa-exclamation-triangle"
            menusystemsubmenu
        >
            <div
                [attr.name]="'risk.detail.menuDetails' | transloco"
                menuicon="fas fa-info-circle"
                menusystemitem
                menuItemId="Details"
            >
                <risk-detail-main
                    [risk]="risk"
                    [parentForm]="parentForm"
                    [permissions]="permissions"
                    [impactScaleData]="impactScaleData"
                    [customFieldData]="customFieldData"
                    #riskDetail
                >
                </risk-detail-main>
            </div>
            @if (risk.id > 0) {
                <div
                    [attr.name]="'risk.detail.menuRiskResultOverview' | transloco"
                    menuItemId="resultOverview"
                    menuicon="fas fa-stream"
                    menusystemitem
                >
                    <risk-result-overview [risk]="risk" #riskResultOverviewComponent>
                    </risk-result-overview>
                </div>
                <div
                    class="risk-screens"
                    [attr.name]="'Links'"
                    menuicon="fas fa-link"
                    menusystemsubmenu
                >
                    <div
                        [attr.name]="'risk.detail.menuControls' | transloco"
                        [attr.menuItemId]="controlsMenuItemId"
                        menuicon="fas fa-shield-alt"
                        menusystemitem
                    >
                        <risk-controls
                            [model]="risk"
                            [disabled]="!permissions.canLinkControls"
                            [permissions]="permissions"
                            #riskControlsComponent
                        >
                        </risk-controls>
                    </div>

                    <div
                        [attr.name]="'risk.detail.menuEvents' | transloco"
                        [attr.menuItemId]="eventsMenuItemId"
                        menuicon="fas fa-bolt"
                        menusystemitem
                    >
                        <risk-events [model]="risk" #riskEventsComponent> </risk-events>
                    </div>

                    @if (permissions.canLinkBim || permissions.canViewMoi) {
                        <div
                            [attr.name]="'risk.detail.menuMeasuresOfImprovement' | transloco"
                            menuicon="fas fa-tasks"
                            [attr.menuItemId]="moisMenuItemId"
                            menusystemitem
                        >
                            <risk-mois
                                [risk]="risk"
                                [permissions]="permissions"
                                [showAdvancedFilters]="true"
                                [activeFilters]="activeFilters"
                                #moisComponent
                            >
                            </risk-mois>
                        </div>
                    }

                    <div
                        [attr.name]="'risk.detail.menuKeyRiskIndicators' | transloco"
                        menuicon="fa-solid fa-gauge-high"
                        menuItemId="kriMenuItemId"
                        menusystemitem
                    >
                        <risk-kri [model]="risk" [permissions]="permissions" #kriComponent>
                        </risk-kri>
                    </div>

                    <div
                        [attr.name]="'risk.detail.menuDataProcessing' | transloco"
                        menuItemId="dataProcessing"
                        menuicon="fas fa-database"
                        menusystemitem
                    >
                        <risk-datamanagement [risk]="risk" #datamanagementComponent>
                        </risk-datamanagement>
                    </div>
                    @if (permissions.canViewTP) {
                        <div
                            menuItemId="menuItemTp"
                            [attr.name]="'risk.detail.menuThirdParty' | transloco"
                            menuicon="fas fa-handshake"
                            menusystemitem
                        >
                            <risk-thirdparty #thirdpartyComponent [risk]="risk" [disabled]="true">
                            </risk-thirdparty>
                        </div>
                    }
                    <div
                        [attr.name]="'risk.detail.menuDocuments' | transloco"
                        [attr.menuItemId]="documentsMenuItemId"
                        menuicon="far fa-file"
                        menusystemitem
                    >
                        @if (risk.Documents) {
                            <div>
                                <document-manager-old
                                    [(Documents)]="risk.Documents"
                                    [permissions]="permissions.documentPermissions"
                                    (DocumentsChange)="documentsChanged($event)"
                                    [DocumentTypeTargets]="targetModule"
                                ></document-manager-old>
                            </div>
                        } @else {
                            <div>
                                <div class="fancy-loader"></div>
                            </div>
                        }
                    </div>
                    <div
                        [attr.name]="'risk.detail.menuHyperlinks' | transloco"
                        [attr.menuItemID]="hyperlinksMenuItemId"
                        menuicon="fas fa-external-link-alt"
                        menusystemitem
                    >
                        @if (risk.Hyperlinks) {
                            <div>
                                <hyperlink-manager
                                    [(Hyperlinks)]="risk.Hyperlinks"
                                    (HyperlinksChanged)="hyperlinksChanged($event)"
                                    [TargetModule]="targetModule"
                                ></hyperlink-manager>
                            </div>
                        } @else {
                            <div>
                                <div class="fancy-loader"></div>
                            </div>
                        }
                    </div>
                </div>

                <div [attr.name]="'risk.detail.menuHistory' | transloco" menuicon="fas fa-history" menusystemitem menuItemId="history">
                    <app-history-overview
                        #historyOverviewComponent
                        [historyDataService]="riskDS"
                        [Id]="risk.guid"
                        [useOldHistory]="true"
                    >
                    </app-history-overview>
                </div>

                <div
                    [attr.name]="'risk.detail.menuOptions' | transloco"
                    menuItemId="options"
                    menuicon="fas fa-check-double"
                    menusystemitem
                >
                    <detail-options
                        moduleName="risk"
                        [objectName]="risk ? risk.name : 'risk'"
                        [allowDelete]="permissions.canDelete"
                        (onDelete)="delete()"
                    >
                    </detail-options>
                </div>
            }
        </div>
    </div>
}
